import { render, staticRenderFns } from "./ChatBoxFlex.vue?vue&type=template&id=1acae471&scoped=true&"
import script from "./ChatBoxFlex.vue?vue&type=script&lang=js&"
export * from "./ChatBoxFlex.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxFlex.vue?vue&type=style&index=0&id=1acae471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acae471",
  null
  
)

export default component.exports